module.exports = __webpack_public_path__ + "img/f2-site.1f9caa19.png";